(function() {
  'use strict';

  angular
    .module('survey.essayDirective', ['factories.mobileHelper'])
    .directive('mfEssay', mfEssay);

  mfEssay.$inject = ['MobileHelper', '$window'];

  function mfEssay(MobileHelper, $window) {
    return {
      link: function(scope, element, attr) {
        var keyboardOpen = false;
        var initialHeight = $(window).height();

        var textArea = element.find('#textArea');

        if (MobileHelper.isMobileDevice()) {
          $(textArea).on('focus', onFocus);
          $(textArea).on('blur', onBlur);
          angular.element($window).on('resize', onResize);
          angular.element($window).on('click', onWindowClick);
          angular.element($window).on('touchend', onWindowTouchEnd);
        }

        function onFocus() {
          $('body').addClass('keyboard-open');
          keyboardOpen = true;
        }

        function onBlur() {
          $('body').removeClass('keyboard-open');
          keyboardOpen = false;
          setTimeout(function() {
            angular.element($window).trigger('resize');
          }, 1);
        }

        function onResize() {
          // In Android if you hit the hardwareback button it'll close the keyboard but not blur the textarea.
          // We know we haven't blurred yet if keyboardOpen is still true so if we hit this case trigger blur.
          if (MobileHelper.isAndroid() && keyboardOpen && angular.element($window).height() == initialHeight)
            $(textArea).trigger('blur');
        }

        function onWindowClick(event) {
          if (event.target.nodeName.toLowerCase() !== 'textarea')
            $(textArea).trigger('blur');
        }

        function onWindowTouchEnd(e) {
          if (e.target.id === 'surveyActionButton')
            scope.onActionButtonClick();
        }

        scope.onClick = function() {
          $(textArea).trigger('focus');
        };

        scope.$on('$destroy', function() {
          $('body').removeClass('keyboard-open');
          angular.element($window).off('click', onWindowClick);
          angular.element($window).off('resize', onResize);
          angular.element($window).off('touchend', onWindowTouchEnd);
        });
      }
    };
  }
})();
